import { getPrimaryLanguage } from "./getPrimaryLanguage";

/**
 * Check if the given language is the primary language of the given country.
 */
export function isPrimaryLanguage(language: string, country: string): boolean {
  return language.toLowerCase() === getPrimaryLanguage(country);
}
